module.exports = __webpack_public_path__ + "66915359b26f36edcae182234efc4103.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Racers/green.ss.png
// module id = 650
// module chunks = 0